export const env = {
  IS_DEV: process.env.NODE_ENV === 'development',
  MAPBOX_TOKEN: process.env.NEXT_PUBLIC_MAPBOX_TOKEN ?? '',
};
